import { html } from 'lit';
const GamePanel =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.106 2.867A3.224 3.224 0 0 0 3.882 6.09v9.67a3.224 3.224 0 0 0 3.224 3.224h3.727a.57.57 0 0 0 .57-.57V3.437a.57.57 0 0 0-.57-.571zm.107 3.682a.885.885 0 1 0 0 1.77h1.142a.885.885 0 1 0 0-1.77zm1.713 7.734a1.142 1.142 0 1 1-2.284 0 1.142 1.142 0 0 1 2.284 0m7.85-9.267A3.224 3.224 0 0 1 20 8.239v9.67a3.224 3.224 0 0 1-3.224 3.224H13.05a.57.57 0 0 1-.57-.57V5.586a.57.57 0 0 1 .57-.571zm-.772 9.724c.378 0 .685.307.685.685v.457h.457a.685.685 0 0 1 0 1.37h-.457v.456a.685.685 0 1 1-1.37 0v-.456h-.457a.685.685 0 1 1 0-1.37h.457v-.457c0-.378.307-.685.685-.685m1.142-6.165a1.142 1.142 0 1 1-2.283 0 1.142 1.142 0 0 1 2.283 0" clip-rule="evenodd"/>
  </svg>
`;
export default GamePanel;
